<template>
  <div>
    <div class="body">
      <div class="search">
        <!-- 客户ID -->
        <div class="item">
          <el-input v-model="datas.user_id" :placeholder="$t('message.userID')" clearable
            onfocus="this.select()"></el-input>
        </div> <!-- 客户名 -->
        <div class="item">
          <el-input v-model="datas.realname" :placeholder="$t('message.userName')" clearable
            onfocus="this.select()"></el-input>
        </div>
        <!-- 手机号-->
        <div class="item">
          <el-input v-model="datas.mobile" :placeholder="$t('message.phoneNumber')" clearable
            onfocus="this.select()"></el-input>
        </div>
        <!-- 邮箱 -->
        <div class="item">
          <el-input v-model="datas.email" :placeholder="$t('message.email')" clearable
            onfocus="this.select()"></el-input>
        </div>
        <!-- 搜索 -->
        <el-button type="primary" @click="clientInfo">
          {{ $t("message.search") }}
        </el-button>
        <!-- 重置 -->
        <el-button @click="reset">
          {{ $t("message.reset") }}
        </el-button>
        <!-- QA  咨询等级 -->
        <div class="operation">
          <!-- QA查询 -->
          <el-button type="primary" @click="$refs.qaQuery.dialogVisible = true">
            {{ $t("message.qaQuery") }}
          </el-button>
          <!-- 咨询登记 -->
          <el-button type="primary" @click="register">
            {{ $t("message.consultationRegistration") }}
          </el-button>
        </div>
      </div>
      <!-- 客户基本信息 -->
      <userInfo ref="userInfo" :detail="detail" v-show="show" />
    </div>
    <!-- 底部子页面 -->
    <div class="body" v-show="show">
      <div class="tabs">
        <!-- 咨询 -->
        <div class="item" :class="{ index: index == 6 }" @click="index = 6">
          {{ $t('message.consultationRegistration') }}
        </div>
        <!-- 进行中订单 -->
        <div class="item" :class="{ index: index == 0 }" @click="index = 0">
          {{ $t('message.orderInProgress') }}
        </div>
        <!-- 进行中配送单 -->
        <div class="item" :class="{ index: index == 1 }" @click="index = 1">
          {{ $t('message.deliveryOrderInProgress') }}
        </div>
        <!-- 出入金列表 -->
        <div class="item" :class="{ index: index == 2 }" @click="index = 2">
          {{ $t('message.adjustList') }}
        </div>
        <!-- 意见反馈 -->
        <div class="item" :class="{ index: index == 3 }" @click="index = 3">
          {{ $t('message.feedback') }}
        </div>
        <!-- 客户评价 -->
        <div class="item" :class="{ index: index == 4 }" @click="index = 4">
          {{ $t('message.customerEvaluation') }}
        </div>
        <!-- 邮件列表 -->
        <div class="item" :class="{ index: index == 5 }" @click="index = 5">
          {{ $t('message.mailList') }}
        </div>


      </div>
      <!-- 咨询 -->
      <consultationRecords ref="consultationRecords" v-show="index == 6" :user_id="detail.id" />
      <!--进行中的订单  -->
      <orderList v-show="index == 0" ref="orderList" :user_id="detail.id" />
      <!--进行中的配送单  -->
      <porderList v-show="index == 1" ref="porderList" :user_id="detail.id" />
      <!-- 出入金 -->
      <receiptsAndReceipts v-show="index == 2" ref="receiptsAndReceipts" :user_id="detail.id" />
      <!-- 意见反馈 -->
      <feedback ref="feedback" v-show="index == 3" :user_id="detail.id" />
      <!-- 客户评价 -->
      <customerEvaluation ref="customerEvaluation" v-show="index == 4" :user_id="detail.id" />
      <!-- 邮件列表 -->
      <mailList ref="mailList" v-show="index == 5" :user_id="detail.id" />


    </div>
    <!-- QA查询 -->
    <qaQuery ref="qaQuery" />
    <!--咨询登记  -->
    <consultationRegistration ref="consultationRegistration" :formData="formData" :isAdd="true" />
  </div>
</template>
<script>
import userInfo from './components/userInfo'
import orderList from './components/orderList'
import porderList from './components/porderList'
import receiptsAndReceipts from './components/receiptsAndReceipts'
import feedback from './components/feedback'
import customerEvaluation from './components/customerEvaluation'
import mailList from './components/mailList'
import qaQuery from './components/qaQuery'
import consultationRegistration from './components/consultationRegistration'
import consultationRecords from './components/consultationRecords'

import { transferDate } from '@/utlis/date'
export default {
  components: {
    userInfo,
    orderList,
    porderList,
    receiptsAndReceipts,
    feedback,
    customerEvaluation,
    mailList,
    qaQuery,
    consultationRegistration,
    consultationRecords
  },
  data() {
    return {
      datas: {},
      show: false,
      index: 6,
      detail: {},
      formData: {},
    };
  },
  methods: {
    //客户基础信息查询
    clientInfo() {
      this.$api.JapaneseOffice.clientInfo(this.datas).then(res => {
        this.detail = res.data
        this.show = true
        this.$nextTick(() => {
          this.$refs.porderList.porderList()
          this.$refs.orderList.orderList()
          this.$refs.receiptsAndReceipts.userBillList()
          this.$refs.feedback.feedbackList()
          this.$refs.customerEvaluation.evaluationlist()
          this.$refs.mailList.emailList()
          this.$refs.consultationRecords.consultList()

        })

      })
    },
    search() {


    },
    reset() {
      this.datas = {}
      this.show = false
    },
    // 咨询登记
    register() {
      this.formData = {
        user_id: this.datas.user_id,
        realname: this.datas.realname,
        source: 'PHONE',
        consult_at: transferDate(new Date()),
        reply: '',
        content: '',
      }
      this.$refs.consultationRegistration.dialogVisible = true
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  position: relative;

  .item {
    width: 180px;
    margin-right: 24px;

  }

  .operation {
    position: absolute;
    right: 0;
    top: 0;
  }
}

.body {
  margin-bottom: 24px;

  .tabs {
    display: flex;
    margin-bottom: 24px;

    .item {
      width: 120px;
      height: 48px;
      border: 2px solid #B4272D;
      border-right: 0;
      color: #B4272D;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      &:nth-last-child(1) {
        border-right: 2px solid #B4272D;
        border-radius: 0px 4px 4px 0px;

      }

      &:nth-child(1) {
        border-radius: 4px 0px 0px 4px;
      }
    }

    .index {
      background-color: #B4272D;
      color: #fff;
    }
  }
}
</style>